const m = require('minthril');
const { component } = require('../../component');

const Breadcrumbs = component(() => ({
  view: ({ attrs: { items = [] } }) => items.length > 1 && m('nav.breadcrumbs', {
    'aria-label': 'Breadcrumb'
  }, items.map((item, index) => [
    index ? m('span.breadcrumbs__separator', ' / ') : null,
    item.href ? m('a', { href: item.href }, item.label) :
      m('span.breadcrumbs__current', item.label)
  ]))
}));

module.exports = { Breadcrumbs };
